import { Container, InputWrap, TotalResultText } from '../users/style';
import {
    Counter,
    Loader,
    TextEditor,
    TextInputComp,
} from '../../common/component';
import { Grid, Header } from '../dashboard/styles';
import { TableCompData } from '../../common/component/table';
import { SubTopicHeader } from '../../common/utils/dataUtils';
import { BsEye } from 'react-icons/bs';
import { AiOutlineDelete } from 'react-icons/ai';
import { ContainerComp } from '../../common/component/Ui/containerComp';
import { Col, FormControl } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { CustomButton } from '../../common/component/button';
import { ModalComp } from '../../common/component/Ui/modalComp';
import SearchIcon from '../../common/images/search_icon.svg';
import { ReactComponent as CareerIcon } from '../../common/images/career_icon.svg';
import { showSuccessToast, showErrorToast } from '../../common/utils/toast';
import { Controller, useForm } from 'react-hook-form';
import { Flexbox2 } from '../currencyPair/style';
import {
    useCreateSubTopicMutation,
    useDeleteSubTopicMutation,
    useGetAllSubTopicQuery,
    useGetAllTopicsQuery,
    useSubTopicStatsQuery,
} from '../../store/topicApi';
import { ITopic } from '../../store/topicApi/interface';
import CustomSearchDropDown from '../../common/component/Ui/customSearch';

interface ITopicValues {
    title: string;
    description: string;
    topic: string;
}

export const SubTopic = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [dropDownTerm, setDropDownTerm] = useState('');
    const [newArray, setNewArray] = useState<ITopic[] | any>();
    const [showModal, setShowModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [subTopicId, setSubTopicId] = useState<any>('');
    const [title, setTitle] = useState<any>();
    const [desc, setDesc] = useState<any>();
    const [topicApiId, setTopicApiId] = useState<any>('');
    const [priority, setPriority] = useState<any>();
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRows, setTotalRows] = useState(100);
    const paginate = {
        perPage: rowsPerPage,
        currentPage: currentPage,
    };

    const {
        data: allSubTopic,
        isLoading,
        isFetching,
    } = useGetAllSubTopicQuery(paginate, {
        refetchOnMountOrArgChange: true,
    });

    const { data: allTopics } = useGetAllTopicsQuery(paginate, {
        refetchOnMountOrArgChange: true,
    });

    const [createSubTopic, { isLoading: isAddSubTopic }] =
        useCreateSubTopicMutation();
    const [deleteSubTopic, { isLoading: isDeleting }] =
        useDeleteSubTopicMutation();
    const { data: subTopicStats } = useSubTopicStatsQuery();
    useEffect(() => {
        setTotalRows(allSubTopic?.pagination?.totalDocumentCount as number);
    }, [allSubTopic?.pagination?.totalDocumentCount]);
    const handlePageChange = (page: any) => setCurrentPage(page);
    const handleRowsPerPageChange = (newRowsPerPage: any) => {
        if (!allSubTopic?.data?.length) return;
        setRowsPerPage(newRowsPerPage);
        setCurrentPage(1);
    };

    const Items = [
        {
            name: ' View Subtopic',
            icon: <BsEye size={15} />,
            link: 'view',
            id: '_id',
        },
        {
            name: ' Delete Subtopic',
            icon: <AiOutlineDelete size={15} />,
            OnClick: (data: any) => {
                setSubTopicId(data?._id);
                setDeleteModal(true);
            },
        },
    ];

    // To implement search and dropdown input
    useEffect(() => {
        if (searchTerm === '' && dropDownTerm === '') {
            setNewArray(allSubTopic?.data);
        }
        if (dropDownTerm !== '') {
            let filteredItems = allSubTopic?.data?.filter((item) => {
                return item?.schedule
                    .toLowerCase()
                    .includes(dropDownTerm.toLowerCase());
            });
            setNewArray(filteredItems);
        }
        if (searchTerm !== '') {
            let searchItems = allSubTopic?.data?.filter((item) => {
                return item?.title
                    ?.toLowerCase()
                    .includes(searchTerm?.toLowerCase());
            });
            setNewArray(searchItems);
        }
    }, [allSubTopic, searchTerm, dropDownTerm]);

    const { handleSubmit, control, reset } = useForm({
        defaultValues: {
            title: '',
            description: '',
            topic: '',
            priority: 0,
        },
    });

    const onHandleSubmit = (value: ITopicValues) => {
        const payload = {
            title: title,
            description: desc,
            topic: topicApiId?.value,
            priority: Number(priority),
        };
        createSubTopic(payload)
            .unwrap()
            .then((result) => {
                console.log('Subtopic added successfully:', result);
                showSuccessToast(result?.message);
                setShowModal(false);
                reset();
            })
            .catch((error) => {
                showErrorToast(error?.data?.message);
            });
    };

    const onDeleteSubTopic = (id: string) => {
        deleteSubTopic(id)
            .unwrap()
            .then((result) => {
                showSuccessToast(result?.message);
                setDeleteModal(false);
            })
            .catch((error) => {
                showErrorToast(error?.data?.message);
            });
    };

    const cleanupTopics = (topicsInQuestion: any) => {
        if (topicsInQuestion) {
            const result = topicsInQuestion.map((topic: any) => {
                return { label: topic.title, value: topic?._id };
            });

            return result;
        }

        return [];
    };

    return (
        <Container>
            {isLoading || isDeleting ? <Loader /> : null}
            <Header>Subtopic</Header>
            <Grid>
                <Counter
                    counter_title="Total Subtopics"
                    count={subTopicStats?.data?.totalSubTopics || 0}
                    iconFill="blue"
                    iconBG="blue"
                >
                    <CareerIcon />
                </Counter>
                <Counter
                    counter_title="Inactive Subtopics"
                    count={subTopicStats?.data?.InActiveSubTopics || 0}
                >
                    <CareerIcon />
                </Counter>
                <Counter
                    counter_title="Active Subtopics"
                    count={subTopicStats?.data?.activeSubTopics || 0}
                    iconFill="green"
                    iconBG="green"
                >
                    <CareerIcon />
                </Counter>
                <Counter
                    counter_title="Deleted Subtopics"
                    count={subTopicStats?.data?.deletedSubTopics || 0}
                    iconFill="red"
                    iconBG="red"
                >
                    <CareerIcon />
                </Counter>
            </Grid>
            <div className="d-xl-flex align-items-center justify-content-between mt-5 mb-3">
                <Col
                    sm={12}
                    xl={8}
                    className="d-flex flex-column flex-sm-row align-items-center justify-content-between"
                >
                    <InputWrap>
                        <img src={SearchIcon} alt="" />
                        <FormControl
                            aria-label="Amount (to the nearest dollar)"
                            placeholder="Search"
                            className="border-start-0 border-bottom-0 border-top-0"
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </InputWrap>
                </Col>
                <div className="d-flex align-items-center justify-content-center justify-content-sm-end my-3">
                    <CustomButton
                        text="Create Subtopic "
                        onClick={() => setShowModal(true)}
                    />
                </div>
            </div>

            <ContainerComp>
                <TableCompData
                    columns={SubTopicHeader(Items)}
                    data={newArray}
                    progressPending={isFetching}
                    totalRows={totalRows}
                    rowsPerPage={rowsPerPage}
                    currentPage={currentPage}
                    handlePageChange={handlePageChange}
                    handleRowsPerPageChange={handleRowsPerPageChange}
                />
            </ContainerComp>
            <ModalComp
                show={showModal}
                handleClose={() => setShowModal(false)}
                centered
                close={true}
                size="lg"
                modalTitle="Create Subtopic"
                paragraph="Fill in the forms to create a Subtopic"
                modalBody={
                    <form onSubmit={handleSubmit(onHandleSubmit)}>
                        <div className="py-1 px-lg-4 ">
                            <div className="my-3">
                                <Controller
                                    name="priority"
                                    control={control}
                                    render={({
                                        field: { value, onChange },
                                    }) => {
                                        setPriority(value);
                                        return (
                                            <TextInputComp
                                                labelText="Priority"
                                                inputClassName={'py-2'}
                                                name="priority"
                                                type="number"
                                                defaultValue={1}
                                                {...{ value, onChange }}
                                            />
                                        );
                                    }}
                                />
                            </div>
                            <div className="mb-4">
                                <div>
                                    {' '}
                                    <Controller
                                        name="topic"
                                        control={control}
                                        rules={{
                                            required: '*Topic is required',
                                            min: '8',
                                        }}
                                        render={({
                                            field: { onChange, value },
                                            formState: { errors },
                                        }) => {
                                            const errorMessage =
                                                errors.topic?.message;
                                            setTopicApiId(value);
                                            return (
                                                <CustomSearchDropDown
                                                    isShowLabel
                                                    placeholder="Select..."
                                                    defaultOptions={cleanupTopics(
                                                        allTopics?.data,
                                                    )}
                                                    label="Select Topic"
                                                    {...{
                                                        value,
                                                        onChange,
                                                        errors: [errorMessage],
                                                    }}
                                                />
                                            );
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="my-4">
                                <Controller
                                    name="title"
                                    control={control}
                                    rules={{
                                        required: 'Subtopic title is required',
                                    }}
                                    render={({
                                        field: { value, onChange },
                                        formState: { errors },
                                    }) => {
                                        const errorMessage =
                                            errors?.title?.message;
                                        setTitle(value);
                                        return (
                                            <TextEditor
                                                {...{
                                                    value,
                                                    onChange,
                                                    errors: [errorMessage],
                                                }}
                                                labelText="Subtopic title"
                                            />
                                        );
                                    }}
                                />
                            </div>

                            <div className="my-4">
                                <Controller
                                    name="description"
                                    control={control}
                                    rules={{
                                        required:
                                            'Subtopic description is required',
                                    }}
                                    render={({
                                        field: { value, onChange },
                                        formState: { errors },
                                    }) => {
                                        const errorMessage =
                                            errors?.title?.message;
                                        setDesc(value);
                                        return (
                                            <TextEditor
                                                {...{
                                                    value,
                                                    onChange,
                                                    errors: [errorMessage],
                                                }}
                                                labelText="Subtopic description"
                                            />
                                        );
                                    }}
                                />
                            </div>

                            <div className="d-flex justify-content-center">
                                <CustomButton
                                    className="py-3 mt-4"
                                    text={
                                        isAddSubTopic
                                            ? 'Loading...'
                                            : 'Create Subtopic'
                                    }
                                />
                            </div>
                        </div>
                    </form>
                }
            />
            <ModalComp
                show={deleteModal}
                handleClose={() => setDeleteModal(false)}
                centered
                close={true}
                modalTitle="Delete Subtopic"
                modalBody={
                    <Flexbox2>
                        <CustomButton
                            className="py-3 mt-4"
                            text={'Cancel'}
                            onClick={() => setDeleteModal(false)}
                        />
                        <CustomButton
                            className="py-3 mt-4"
                            text={!isDeleting ? 'Delete' : 'Loading...'}
                            onClick={() => onDeleteSubTopic(subTopicId)}
                        />
                    </Flexbox2>
                }
            />
        </Container>
    );
};
